import type { OhlcBar } from '@shared/types'

export interface LinePoint {
  time: number | string
  value: number
}

export function sma(bars: OhlcBar[], period: number): LinePoint[] {
  if (period < 1) return []
  const out: LinePoint[] = []
  let sum = 0
  for (let i = 0; i < bars.length; i++) {
    sum += bars[i].close
    if (i >= period) sum -= bars[i - period].close
    if (i >= period - 1) out.push({ time: bars[i].time, value: sum / period })
  }
  return out
}

export function ema(bars: OhlcBar[], period: number): LinePoint[] {
  if (period < 1 || !bars.length) return []
  const out: LinePoint[] = []
  const k = 2 / (period + 1)
  let prev = bars[0].close
  for (let i = 0; i < bars.length; i++) {
    const c = bars[i].close
    prev = i === 0 ? c : c * k + prev * (1 - k)
    if (i >= period - 1) out.push({ time: bars[i].time, value: prev })
  }
  return out
}

export function rsi(bars: OhlcBar[], period = 14): LinePoint[] {
  if (bars.length <= period) return []
  const out: LinePoint[] = []
  let avgGain = 0
  let avgLoss = 0
  for (let i = 1; i <= period; i++) {
    const ch = bars[i].close - bars[i - 1].close
    avgGain += Math.max(ch, 0)
    avgLoss += Math.max(-ch, 0)
  }
  avgGain /= period
  avgLoss /= period
  const push = (i: number) => {
    const rs = avgLoss === 0 ? 100 : avgGain / avgLoss
    out.push({ time: bars[i].time, value: avgLoss === 0 ? 100 : 100 - 100 / (1 + rs) })
  }
  push(period)
  for (let i = period + 1; i < bars.length; i++) {
    const ch = bars[i].close - bars[i - 1].close
    avgGain = (avgGain * (period - 1) + Math.max(ch, 0)) / period
    avgLoss = (avgLoss * (period - 1) + Math.max(-ch, 0)) / period
    push(i)
  }
  return out
}
